// extracted by mini-css-extract-plugin
export default {"table":"FeatureFlags_table__SOut2"};